// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-input {
  color: black;
  --padding-top: 0;
  --padding-end: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  background: white;
  font-size: 30px;
}

.spinner-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

ion-spinner {
  width: 30px;
  height: 30px;
  color: black;
}

.back-icon {
  color: black;
}

.error-message-container {
  background: #fef2f2;
  border: 2px solid #fca5a5;
  border-left-width: 6px;
}

.error-message-inline {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.error-message-inline p {
  margin: 0;
}

.error-message-text {
  width: 100%;
  padding: 0 8px;
  text-align: center;
  color: #d32f2f;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
}

.underline-div {
  height: 1px;
  align-self: end;
  margin: 0;
  border-bottom: 1px solid #d1d1d1;
  width: 100%;
  padding-top: 2.5rem;
}

.firmware-ready-row {
  color: #41505a !important;
  margin: 0;
  padding-top: 2rem;
}

.firmware-preparing {
  color: #41505a !important;
  margin: 0;
  padding-top: 2rem;
}

.sparepar-button {
  width: 8rem;
}

.action-row {
  display: flex;
  gap: 12px;
}

.action-row--center {
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/main/pages/spare-part-modal/spare-part-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAAF;;AAEE;EACE,SAAA;AAAJ;;AAIA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AADF;;AAIA;EACE,WAAA;EACA,eAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,mBAAA;AADF;;AAGA;EACE,yBAAA;EACA,SAAA;EACA,iBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,SAAA;EACA,iBAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,uBAAA;AACF","sourcesContent":["ion-input {\r\n  color: black;\r\n  --padding-top: 0;\r\n  --padding-end: 0;\r\n  --padding-bottom: 0;\r\n  --padding-start: 0;\r\n  background: white;\r\n  font-size: 30px;\r\n}\r\n\r\n.spinner-container {\r\n  position: relative;\r\n\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\nion-spinner {\r\n  width: 30px;\r\n  height: 30px;\r\n  color: black;\r\n}\r\n\r\n.back-icon {\r\n  color: black;\r\n}\r\n\r\n.error-message-container {\r\n  background: #fef2f2;\r\n  border: 2px solid #fca5a5;\r\n  border-left-width: 6px;\r\n}\r\n\r\n.error-message-inline {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n\r\n  p {\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n.error-message-text {\r\n  width: 100%;\r\n  padding: 0 8px;\r\n  text-align: center;\r\n  color: #d32f2f;\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n  margin: 0;\r\n}\r\n\r\n.underline-div {\r\n  height: 1px;\r\n  align-self: end;\r\n  margin: 0;\r\n  border-bottom: 1px solid #d1d1d1;\r\n  width: 100%;\r\n  padding-top: 2.5rem;\r\n}\r\n.firmware-ready-row {\r\n  color: #41505a !important;\r\n  margin: 0;\r\n  padding-top: 2rem;\r\n}\r\n\r\n.firmware-preparing {\r\n  color: #41505a !important;\r\n  margin: 0;\r\n  padding-top: 2rem;\r\n}\r\n\r\n.sparepar-button {\r\n  width: 8rem;\r\n}\r\n.action-row {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.action-row--center {\r\n  justify-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
